import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BiometryDeviceMake, BiometryFinger, BiometryHand, BiometryType } from 'src/app/@core/constants';
import { Customer } from 'src/app/models/customer';
import { Param } from 'src/app/models/param';
import { BiometryValidationResponse } from 'src/app/models/response/biometry-validation-response';
import { CaptureFingerPrintResponse } from 'src/app/models/response/CaptureFingerPrintResponse';
import { CaptureFingerPrintSecuGenResponse } from 'src/app/models/response/CaptureFingerPrintSecuGenResponse';
import { AuthService } from 'src/app/services/auth.service';
import { BiometryService } from 'src/app/services/biometry.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ExceptionSolutionService } from 'src/app/services/exception-solution.service';
import { ParamsService } from 'src/app/services/params.service';

@Component({
  selector: 'app-biometry-finger-print',
  templateUrl: './biometryFingerPrint.component.html',
  styleUrls: ['./biometryFingerPrint.component.sass']
})
export class BiometryFingerPrintComponent implements OnInit {

  public _biometryFinger = BiometryFinger;
  public _biometryHand = BiometryHand;

  public biometryHand?: BiometryHand;
  public biometryFinger: BiometryFinger = BiometryFinger.INDEX;
  public biometryDeviceMake: BiometryDeviceMake | undefined = undefined;
  public imageFingerPrint: string = "";
  private device: string = "";
  public attempts = 0;

  private branchCodesInactiveNewDeviceFingerprint: Param = new Param();
  public showSelectDevice: boolean = false;

  @Input() customerSelected: Customer = new Customer();
  @Input() isForInvoice = false;
  @Input() isForCashLoan = false;
  @Input() isForCreditRequest = false;
  @Input() showActionButtonWithApprove = false;
  @Input() showActionButtonWithoutApprove = false;
  @Input() textActionButtonWithApprove = ``;
  @Input() textActionButtonWithoutApprove = ``;
  @Input() creditRequestNumber = ``;

  @Output() biometryResultEmitter =
    new EventEmitter<BiometryValidationResponse>();
  @Output() biometryErrorEmitter = new EventEmitter();
  @Output() cleanEmitter = new EventEmitter();
  @Output() clickActionButtonWithApprove = new EventEmitter();
  @Output() clickActionButtonWithoutApprove = new EventEmitter();

  public result: BiometryValidationResponse = new BiometryValidationResponse();

  @Input() biometryCompleted = false;
  constructor(private datePipe: DatePipe, private biometryService: BiometryService,
    private configService: ConfigurationService, private authService: AuthService,
    private toastrService: ToastrService, private paramsService: ParamsService, private readonly exceptionSolutionService: ExceptionSolutionService) { }

  async ngOnInit() {
    this.branchCodesInactiveNewDeviceFingerprint =
      (await this.paramsService.readParam("branch-codes-inactive-new-device-fingerprint").toPromise()).response;

    this.showSelectDevice = !this.branchCodesInactiveNewDeviceFingerprint.value
      .includes(this.configService.readSelectedBranchAndSalesOrg().branch.code);
  }

  async capture() {
    this.clean();

    if (!this.showSelectDevice)
      this.biometryDeviceMake = BiometryDeviceMake.ZKTECO;

    if (this.biometryDeviceMake == BiometryDeviceMake.ZKTECO)
      await this.captureZKTeco();
    if (this.biometryDeviceMake == BiometryDeviceMake.SECUGEN)
      await this.captureSecuGen();
  }

  async captureZKTeco() {
    this.imageFingerPrint = "assets/hands/fingerPrintCapture.gif";
    let data: CaptureFingerPrintResponse = (await this.biometryService.captureFingerprint(this.device).toPromise());

    if (data.capture) {
      this.imageFingerPrint = "data:image/jpeg;base64," + data.imageBase64;
    }
    else {
      this.exceptionSolutionService.showAlertWithSolution(`Biometria`, `No se capturo huella vuelva a intentarlo`);
      this.imageFingerPrint = "";
    }
  }

  async captureSecuGen() {
    this.imageFingerPrint = "assets/hands/fingerPrintCapture.gif";
    let data: CaptureFingerPrintSecuGenResponse = (await this.biometryService.captureFingerprintSecuGen(this.device).toPromise());

    if (data.ErrorCode == 0) {
      this.imageFingerPrint = "data:image/bmp;base64," + data.BMPBase64;
    }
    else {
      this.toastrService.error("No se capturo huella vuelva a intentarlo");
      this.imageFingerPrint = "";
    }
  }

  async sendFingerPrint() {
    try {

      this.result = new BiometryValidationResponse();
      if (this.customerSelected.code != "") {
        let response = this.result = (await this.biometryService.validateBiometry({
          branchCode: this.configService.readSelectedBranchAndSalesOrg().branch.code,
          customerCode: this.customerSelected.code,
          imageFileName: `${this.customerSelected.code}.jpg`,
          imageStringBase64: this.imageFingerPrint,
          type: BiometryType.FINGERPRINT,
          user: (await this.authService.readProfile()).username,
          hand: this.biometryHand,
          finger: this.biometryFinger,
          creditRequestNumber: this.creditRequestNumber
        }).toPromise()).response;
        if (response != undefined) {
          this.result = response;
          if (!this.result.valid) {
            this.attempts++;
          } else {
            this.attempts = 0;
          }
        }
        this.result.origin = `fingerprint`;
        this.biometryResultEmitter.emit(this.result);
      }
      else {
        this.exceptionSolutionService.showAlertWithSolution(`Biometria`, `Seleccione un cliente antes de validar la huella`);
      }
    } catch (error: any) {
      this.biometryErrorEmitter.emit({ ...error, origin: 'fingerprint' });
      this.attempts++;
      throw error;
    }
  }

  async switchDeviceMake(event: MouseEvent) {
    this.clean();
    this.biometryDeviceMake = (event.target as HTMLInputElement).value == "ZKTECO" ? BiometryDeviceMake.ZKTECO : BiometryDeviceMake.SECUGEN;

    if (this.biometryDeviceMake == BiometryDeviceMake.ZKTECO) {
      let activeFingerprint = (await this.biometryService.activeFingerprint().toPromise());
      if (activeFingerprint.active) {
        this.device = activeFingerprint.device.toString();
      }
      else {
        this.toastrService.error("Error al activar el dispositivo");
      }
    }
  }

  async switchHand(event: MouseEvent) {
    this.clean();
    this.biometryHand = (event.target as HTMLInputElement).value as BiometryHand;

    if (!this.showSelectDevice) {
      let activeFingerprint = (await this.biometryService.activeFingerprint().toPromise());
      if (activeFingerprint.active) {
        this.device = activeFingerprint.device.toString();
      }
      else {
        this.exceptionSolutionService.showAlertWithSolution(`Biometria`, `Error al activar el dispositivo`);
      }
    }
  }

  async switchFinger(event: MouseEvent) {
    this.clean();
    this.biometryFinger = (event.target as HTMLInputElement).value as BiometryFinger;
  }

  clean() {
    this.result = new BiometryValidationResponse();
    this.imageFingerPrint = "";
    this.cleanEmitter.emit();
  }
}
